import { render, staticRenderFns } from "./IpoDraft.vue?vue&type=template&id=61d26fc8&scoped=true"
import script from "./IpoDraft.vue?vue&type=script&lang=js"
export * from "./IpoDraft.vue?vue&type=script&lang=js"
import style0 from "./IpoDraft.vue?vue&type=style&index=0&id=61d26fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d26fc8",
  null
  
)

export default component.exports